import { Route, Routes } from "react-router-dom";
import AdminDashboard from "../Admin/AdminDashboard/Index";
import ProtectedRoute from "../components/Common/ProtectedRoute";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};



export default AdminRoutes;